import { render } from "./Show.vue?vue&type=template&id=71fd6372&scoped=true"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"

import "./Show.vue?vue&type=style&index=0&id=71fd6372&scoped=true&lang=css"

import exportComponent from "/data0/www.sxsmdx.cn/src/ui/src-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71fd6372"]])

export default __exports__